import { render, staticRenderFns } from "./group_list_item_prevent_delete_modal.vue?vue&type=template&id=5b2a6291"
import script from "./group_list_item_prevent_delete_modal.vue?vue&type=script&lang=js"
export * from "./group_list_item_prevent_delete_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports